import { useTranslation } from 'react-i18next'

import { ConfirmationDialog } from '@dhl/confirmation-dialog'

type Props = {
  open: boolean
  onAccept: () => void
  onReject: () => void
}

export const GenericCancelDialog = ({ open, onAccept, onReject }: Props) => {
  const { t } = useTranslation()

  return (
    <ConfirmationDialog
      open={open}
      titleText={t('admin.cancelDialog.titleText')}
      acceptText={t('admin.cancelDialog.acceptText')}
      rejectText={t('admin.cancelDialog.rejectText')}
      onAccept={onAccept}
      onReject={onReject}
    >
      {t('admin.cancelDialog.content')}
    </ConfirmationDialog>
  )
}
